import React from "react";
import AppDownloadSection from "./AppDownloadSection";
import FooterLinks from "../../user_module/components/FooterLinks";

const CombinedSection = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        padding: "40px 20px",
        backgroundColor: "#f7f7f7",
        flexWrap: "wrap", // responsive for mobile
        gap: "20px",
      }}
    >
      {/* Left Side: App Download Section */}
      <div style={{ flex: 1, minWidth: "320px" }}>
        <AppDownloadSection />
      </div>

      {/* Right Side: Footer Links */}
      <div style={{ flex: 1, minWidth: "300px" }}>
        <FooterLinks />
      </div>
    </div>
  );
};

export default CombinedSection;
